const fulfillRules = (question, isFormRequiredActive, rule) => {
	if (question.hasOwnProperty("specialRule")) {
		const specialRule = question.specialRule;
		return isFormRequiredActive === specialRule;
	} else {
		return isFormRequiredActive;
	}
};

export const checkSpecialRequirement = (question, data) => {
	const hasParentRequirement = question.hasOwnProperty("parentSpecialRequirement");
	const hasRequirement = question.hasOwnProperty("specialRequirement");
	const isFreeFromRequirements = !hasParentRequirement && !hasRequirement;

	if (isFreeFromRequirements) return true;

	const { formData, parentFormData } = data;
	if (hasParentRequirement) {
		return parentFormData[question.parentSpecialRequirement] === question.specialRule;
	}

	const isArray = Array.isArray(question.specialRequirement);

	if (isArray) {
		const specialRuleIsArray = Array.isArray(question?.specialRule);
		if (specialRuleIsArray) {
			return question.specialRequirement.some((requirement, index) => {
				const isFormRequiredActive = formData[requirement];
				return isFormRequiredActive === question.specialRule[index];
			});
		}
		return question.specialRequirement.every((requirement) => {
			const isFormRequiredActive = formData[requirement];
			return fulfillRules(question, isFormRequiredActive);
		});
	}

	const isFormRequiredActive = formData[question.specialRequirement];
	return fulfillRules(question, isFormRequiredActive);
};

export const isCurrentLevel = (currentDisplayedForm, formLevel) => {
	const isLevel2 = currentDisplayedForm.level === 2;
	const isSameSubCategory = currentDisplayedForm?.position?.subCategories === formLevel?.position?.subCategories;
	const isSameOption = currentDisplayedForm?.position?.Opciones === formLevel?.position?.Opciones;
	const isLevelLowerThan2 = currentDisplayedForm.level < 2;
	const isSameLevel = currentDisplayedForm.level === formLevel.level;
	const isSameSubLevel = currentDisplayedForm.subLevel === formLevel.subLevel;
	const isParentOrSameCategory = isLevelLowerThan2 && isSameLevel && isSameSubLevel;
	const isSamePosition = isLevel2 && isSameSubCategory && isSameOption;

	return isParentOrSameCategory || isSamePosition;
};
